import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CSSProperties } from 'react';

const resizeIndicator: CSSProperties = {
  backgroundColor: '#4c9aff',
  display: 'inline-block',
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: 2,
};

const resizeIndicatorLeft: CSSProperties = {
  ...resizeIndicator,
  left: 0,
};

const resizeIndicatorRight: CSSProperties = {
  ...resizeIndicator,
  right: 0,
};

export const useDrawerStyles = makeStyles<Theme>(theme => {
  const transition = theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  });

  return {
    drawerWrapper: {
      height: '100%',
      position: 'absolute',
      top: 0,
    },
    drawer: {
      height: '100%',
      maxWidth: '100%',
      position: 'relative !important' as any,
      // MUI v5 applies theme.zIndex.drawer (1200) to permanent drawers; v4 did not.
      // Keep the sidebar below table filter poppers and other content overlays.
      zIndex: 10,
    },
    drawerWrapperClose: {
      width: theme.spacing(3) + 1,
    },
    drawerClose: {
      height: '100%',
      overflowX: 'visible',
      width: theme.spacing(3) + 1,
      zIndex: 0,
    },
    drawerAnimation: {
      transition,
    },
    drawerRight: {
      right: 0,
      left: 'auto',
    },
    paper: {
      width: '100%',
      overflow: 'visible !important' as any,
      position: 'relative !important' as any,
      zIndex: 10,
      boxSizing: 'border-box',
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
    },
    drawerHeaderLeft: {
      ...theme.mixins.toolbar,
      justifyContent: 'flex-start',
    },
    drawerHeaderRight: {
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    drawerButton: {
      '&': {
        borderRadius: '50% !important',
        position: 'absolute !important',
      },
      minWidth: 36,
      width: 36,
      zIndex: 10000,
    },
    drawerButtonLeft: {
      right: -16,
    },
    drawerButtonRight: {
      left: -16,
    },
    title: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    titleLeft: {
      marginRight: 16,
    },
    titleRight: {
      marginLeft: 16,
    },
    resizeControl: {
      cursor: 'ew-resize',
      position: 'absolute',
      top: 0,
      bottom: 0,
      width: 24,
    },
    resizeControlLeft: {
      right: -24,
      '&:hover > span': resizeIndicatorLeft,
    },
    resizeControlRight: {
      left: -24,
      '&:hover > span': resizeIndicatorRight,
    },
    resizeIndicatorLeft: resizeIndicatorLeft as any,
    resizeIndicatorRight: resizeIndicatorRight as any,
    hidden: {
      display: 'none',
    },
  };
});
